<template>
  <div class="message">
    <ul :role="role" v-if="listMess.length > 0" style="margin-bottom: 0px;">
      <li v-for="(mess, index)  in listMess" :key="index" :class="classType">
        <span class="font-weight-bold" v-html="listMess[index]" style="font-size: 13px"></span>
      </li>
    </ul>
    <ul :role="role" v-if="mapMsg != null && mapMsg != undefined && mapMsg.length > 0" >
      <li v-for="(item, index)  in mapMsg" :key="index" :class="classType">
        <a href="javascript:void(0)" @click="focusItem(item.key, idScreen)" style="color:#dc3545; font-size: 13px"><span class="font-weight-bold" v-html="item.mess"></span></a>
      </li>
    </ul>
  </div>
</template>

<script>
  /* eslint-disable */
  import $ from 'jquery';
  import EventBus from "../assets/js/eventBus";
  import common from '../assets/js/common';

  export default {
    name: "message",
    data() {
      return {
        common:common
      }
    },
    props:{
      /**
       * 
       */
      role: {
        type: String,
        default: "alert",
        required: false
      },
      /**
       * 
       */
      classType: {
        type: String,
        default: "text-danger",
        required: false
      },
      /**
       * 
       */
      listMess: {
        type: Array,
        default: function() {
          return [];
        },
        required: false
      },
      /**
       * 
       */
      mapMsg: {
        type: Array,
        default: function() {
          return [];
        },
        required: false
      },
      /**
       * 
       */
      idScreen: {
        type: String,
        default: '',
        required: false
      }
    },
    mounted: function() {
    },
    methods: {
      focusItem: function(key, ptId){
        if(ptId != null && ptId != undefined  && ptId != ''){
          $('.' + ptId + ' #' + key).focus();
        }else{
          $('#' + key).focus();
        }
          
      }
    }
  }
</script>
<style scoped>
.message a, .message span{
  color: #dc3545!important;
}
</style>
